<template>
  <div class="image-ad_simple-image" :style="style">
    <component :is="tagName" class="image-wrap"
               v-for="item in config.sub_entry"
               :href="item.link_url"
               :style="itemStyle"
               :key="item.key">
      <van-image :src="item.image_url"/>
      <div class="link-title" v-if="item.title">{{item.title}}</div>
    </component>
  </div>
</template>

<script>
  export default {
	name: "SimpleImage",
	components: {},
	props: {
	  config: Object
	},
	data() {
	  return {};
	},
	created() {
	},
	methods: {},
	computed: {
	  tagName() {
		return this.$IS_PREVIEW ? 'div' : 'a';
	  },
	  style() {
		if (this.config.sub_entry.length) return {marginBottom: -this.config.image_margin + "px"};
		return "";
	  },
	  itemStyle() {
		return {
		  borderRadius: this.config.corner_type ? "10px" : "",
		  boxShadow: this.config.image_style ? "0 4px 10px rgba(47,54,70,0.1)" : "",
		  marginBottom: this.config.image_margin + "px"
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .image-ad_simple-image {
    .image-wrap {
      overflow: hidden;
      display: block;

      .van-image {
        display: block;
      }
    }
  }
</style>
